module.exports = __webpack_public_path__ + "57c119b20eb4a447eb966ff2f4bf020a.svg";